import moment from 'moment-timezone';

export const getInitials = (firstName: string, lastName?: string): string => {
   const firstInitial = firstName?.charAt(0).toUpperCase() || ''
   const lastInitial = lastName?.charAt(0).toUpperCase() || ''

   return firstInitial + lastInitial
}

export const getFullname = (firstName: string = '', lastName?: string): string => {
   if (!lastName) return firstName?.trim();

   return `${firstName.trim()} ${lastName.trim()}`.trim();
}

export const getShortTimeText = (lastLogin?: string | Date): string => {
   if (!lastLogin) return '';

   const loginMoment = typeof lastLogin === 'string'
      ? moment.utc(lastLogin).local()
      : moment(lastLogin);

   if (!loginMoment.isValid()) return '';

   const now = moment();
   const diffDays = now.diff(loginMoment, 'days', true);

   if (diffDays <= 7) {
      return loginMoment.format('MMMM D, YYYY');
   }

   const diffYears = now.diff(loginMoment, 'years', true);
   const diffMonths = now.diff(loginMoment, 'months', true);
   const diffWeeks = now.diff(loginMoment, 'weeks', true);

   if (diffYears >= 1) return `${Math.ceil(diffYears)} years ago`;
   if (diffMonths >= 1) return `${Math.ceil(diffMonths)} months ago`;
   return `${Math.ceil(diffWeeks)} weeks ago`;
}

export const toSentenceCase = (text: string): string => {
   if (!text || !text?.length) {
      return ''
   }

   const tempText: string = text.trim().toLowerCase()

   return tempText.replace(tempText.charAt(0), tempText.charAt(0).toUpperCase())
}

export const toPlural = (value: number, single: string, plural: string, emptyZero: boolean = true) => {
   if (value === 0) return emptyZero ? '' : `no ${single}`
   else if (value === 1) return `1 ${single}`
   else return `${value} ${plural}`
}

export const formatRoomTypeLabel = (roomName?: string, roomNumber?: number): string => {
   if (roomNumber && roomNumber > 1) {
      return `(${roomNumber}x) ${roomName ?? ''}`
   }
   return roomName ?? ''
}